// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"vmf7hVi6_NdHfS7FqaRM_"};